module.exports = new __parcel__URL__("buckley-coding.844c6201.png").toString();